import { calculateRiskRewardRatio } from './calculateRiskRewardRatio'
import { findTarget } from './findTarget'

export const calculateValues = (
	high_1_price: number,
	high_2_price: number,
	high_3_price: number,
	low_1_price: number,
	low_2_price: number,
	low_3_price: number,
	axis: number,
	isLong: boolean,
	isLog: boolean,
) => {
	const interim1 = findTarget(high_3_price, low_3_price, axis, isLong, isLog)
	const interim2 = findTarget(high_2_price, low_2_price, axis, isLong, isLog)
	const target = findTarget(high_1_price, low_1_price, axis, isLong, isLog)

	const riskRewardRatio = calculateRiskRewardRatio(
		high_3_price,
		low_3_price,
		target,
		isLong,
	)

	return {
		target,
		interim2,
		interim1,
		riskRewardRatio,
	}
}
